var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-80px mb-md-100px mb-lg-120px"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-img', {
    staticClass: "rounded-xl",
    attrs: {
      "src": '/images/sub/product/product-' + _vm.num + '.jpg'
    }
  })], 1), _c('v-col', [_c('v-sheet', {
    staticClass: "py-24px pl-md-80px"
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--sm"
  }, [_c('u-tit-default', [_vm._v(_vm._s(_vm.$t(_vm.name)))])], 1), _c('u-tit-default', {
    staticClass: "tit--xs mb-12px mb-md-14px mb-lg-16px"
  }, [_c('span', {
    staticClass: "primary px-4px py-4px px-lg-8px line-height-15 break-keep"
  }, [_vm._v(_vm._s(_vm.$t(_vm.tag)))])]), _c('txt-primary', {
    staticClass: "grey--text text--darken-4"
  }, [_vm._t("txt")], 2)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }